export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4691.99a0b0ce.jpg";